import { SplitContext } from '@splitsoftware/splitio-react';
import { ISplitContextValues } from '@splitsoftware/splitio-react/types/types';
import { useContext } from 'react';

const useSplit = (): ISplitContextValues => useContext(SplitContext);

export default useSplit;
